import { ThemeOptions } from '@mui/material';
import { MuiOutlinedInput } from '@/components/form/uncontrolled/Input/Input.theme';
import { MuiClockStyles, MuiMultiSectionDigitalClockSectionStyles } from '@/styles/theme/defaultTheme/components';
import { breakpoints } from './breakpoints';
import { palette } from './palette';
import { typography } from './typography';

export const defaultTheme: ThemeOptions = {
  typography,
  palette,
  breakpoints,
  components: {
    ...MuiOutlinedInput,
    ...MuiMultiSectionDigitalClockSectionStyles,
    ...MuiClockStyles,
    MuiTypography: {
      styleOverrides: {
        root: {
          fontVariantNumeric: 'lining-nums',
        },
      },
    },
  },
};
